export const BORDER_RADIUS = '23px'


// WEBPACK FOOTER //
// ./src/constants/cssVariables.js